import React, { FunctionComponent } from "react";
import { Theme, makeStyles, Grid, IconButton } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    borderRadius: 10,
    "&:disabled": {
      backgroundColor: theme.palette.grey["200"],
    },
  },
}));

interface IOnboardingNavButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const OnboardingNavButton: FunctionComponent<IOnboardingNavButtonProps> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { children = t("onboarding.next.button"), onClick } = props;
  return (
    <Grid container>
      <IconButton onClick={onClick} className={classes.button} disabled={props.disabled}>
        {children}
      </IconButton>
    </Grid>
  );
};
